import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { Message } from 'element-ui';
// 引入vue全局自定义过滤器
import './assets/js/vue_filter'
// 引入全局axios对象
import './assets/js/axios.config'
// 引入全局工具对象util
import {recoverVuex,requestDataIfAbsent} from './assets/js/util/common_util';
// 引入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入全局自定义样式
import './assets/css/common_style.styl'
//引入video.js
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
//注入全局对象videojs
Vue.prototype.videojs = Videojs


Vue.use(ElementUI)

// 配置后端基础url
// 配置axios.defaults.baseUrl
Vue.prototype.axios.defaults.baseURL = 'http://119.45.53.152:80/api/'
// Vue.prototype.axios.defaults.baseURL = 'http://localhost:80/api/'
console.log('++++axios base url:')
console.log(Vue.prototype.axios.defaults.baseURL)

//配置websocket地址
Vue.prototype.webSocketUrl = 'ws://119.45.53.152:5050/api/websocket/'
// Vue.prototype.webSocketUrl = 'ws://localhost:5050/api/websocket/'

// 为避免用户按浏览器刷新按钮后，vuex中数据丢失
// 将vuex数据缓存入sessionStorage，用户不关闭浏览器，sessionStorage中数据一直存在
// 从sessionStorage中读取缓存的Vuex中的数据
recoverVuex(store.state)
// 专业、大学数组为空，向后端请求数据
requestDataIfAbsent(['majors','colleges','subjects','years'], store)

// 路由拦截器必须放在new Vue之前，否则不起作用
router.beforeEach((to, from, next) => {
  //定义需要登陆的页面
  let noNeedLoginRoutes = ['/login','/register'];

  let needVipRoutes = ['/selectcollege','/queryCollege','/selectsubject']

  // 不需要登陆的路由，直接跳转
  if(noNeedLoginRoutes.indexOf(to.path)>=0){
    next()
    return
  }

  let userinfo = store.state.userinfo

  //需要登陆的路由
  //没有登陆，则跳转到登陆页面
  const isLogin = userinfo.isLogin
  // 这里读不到vuex的storee
  // 继续跳转
  if(!isLogin){
    next('/login')
    return
  }

  //若没有vip权限，要访问vip路由
  if(needVipRoutes.indexOf(to.path)>=0 && !userinfo.isVip){
    Message('需要VIP权限，请联系管理员')
    return
  }

  //路由跳转
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
